import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { GAME_INFO_CHANNELS } from '@bg-shared/constants/socketChannels';
import { ILotteryDraw } from '@bg-shared/interfaces/Draws/ILotteryDraw';
import { gamesStatusService } from '@bg-shared/business/GamesStatus';
import { gamesRunsEntity } from '@bg-shared/business/GamesRuns';
import { HOLD_DRAW_UPDATE_TIME } from '@bg-shared/constants/constants';
import { ILotteryGameId } from '@bg-shared/interfaces/GameId';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { GameRouletteStore } from '@bg-shared/business/Games/Roulette/GameRoulette.entity';
import { isGameActive } from '@bg-shared/utils/isGameActive';
import { balanceSelectors, balanceStore } from '@bg-shared/business/Balance';
import { webAPIIntegration } from '@bg-shared/integrations';

class GameRouletteEvents {
    public configure(gameId: ILotteryGameId, gameRouletteStore: GameRouletteStore): void {
        webSocketsRepository.on<ILotteryDraw>(GAME_INFO_CHANNELS[gameId], (data) => {
            setTimeout(
                () => {
                    if (isGameActive(gameId)) {
                        const params = {
                            balance: balanceSelectors.getBalance(gameId)(balanceStore.value),
                            prevRunId: gamesRunsEntity.store(gameId).value.run.id,
                        };

                        webAPIIntegration(partnerSettingsStore.webIntegrationType, (api) => {
                            api.runFinished(params);
                        });
                    }

                    gamesRunsEntity.store(gameId).update({
                        run: {
                            id: Number(data.runId),
                            code: data.drawCode,
                        },
                    });

                    gameRouletteStore.updateGame(data.infoTime * 1000, data);

                    gamesStatusService.updateTimer({
                        gameId,
                        seconds: data.secondsLeft,
                        timestamp: data.infoTime,
                    });
                },
                HOLD_DRAW_UPDATE_TIME[gameId] + partnerSettingsStore.getGameDelay(gameId),
            );
        });
    }
}

export const gameRouletteEvents = new GameRouletteEvents();
